"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.batchObservable = batchObservable;
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const batch = [];
function processBatch() {
    for (const item of batch) {
        item.observableValue.set(item.value);
    }
}
function resolveBatch() {
    (0, mobx_1.transaction)(processBatch);
    batch.length = 0;
}
const resolveBatchTask = new core_shared_1.IkeDelayedTask(resolveBatch, 100);
function ensureObservable(target, observableName) {
    if (target[observableName] != null) {
        return target[observableName];
    }
    const observableValue = mobx_1.observable.box(null, { name: observableName, deep: false });
    target[observableName] = observableValue;
    return observableValue;
}
/** mobx.observable which sets immediatly but notifies after a short delay */
function batchObservable(target, propertyName) {
    const observableName = '_' + propertyName;
    const internalValueName = '__' + propertyName;
    Object.defineProperty(target, propertyName, {
        enumerable: true,
        get: function () {
            const observableValue = ensureObservable(this, observableName);
            observableValue.get();
            return this[internalValueName];
        },
        set: function (value) {
            const observableValue = ensureObservable(this, observableName);
            // Set value immediatly for sync get
            this[internalValueName] = value;
            // Delay mobx set to batch reactions
            batch.push({ observableValue, value });
            resolveBatchTask.delay();
        },
    });
}
//# sourceMappingURL=batch.observable.js.map